import axios from 'axios';
import { deliveryStatusParam } from '@helpers/emailDelivery';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ActionTypes,
  EmailAuditPage,
  FetchAuditRequestAction,
  fetchAuditFailure,
  fetchAuditSuccess,
} from './actions';

/** The BFF query string for a filter state. `all` and empty values are left out. */
export function auditQueryString(filters: FetchAuditRequestAction['payload']): string {
  const params = new URLSearchParams({
    page:       String(filters.page),
    size:       String(filters.size),
    periodDays: String(filters.periodDays),
  });
  if (filters.userType)                         params.set('userType',    filters.userType);
  if (filters.templateKey)                      params.set('templateKey', filters.templateKey);
  if (filters.hasOpened  !== 'all')             params.set('hasOpened',   filters.hasOpened);
  if (filters.hasClicked !== 'all')             params.set('hasClicked',  filters.hasClicked);
  if (filters.search)                           params.set('search',      filters.search);
  const delivery = deliveryStatusParam(filters.deliveryStatus);
  if (delivery)                                 params.set('deliveryStatus', delivery);
  return params.toString();
}

async function apiFetchAudit(filters: FetchAuditRequestAction['payload']): Promise<EmailAuditPage> {
  const res = await axios.get(`/api/email-audit?${auditQueryString(filters)}`);
  return res.data as EmailAuditPage;
}

function* fetchAuditSaga(action: FetchAuditRequestAction) {
  try {
    const data: EmailAuditPage = yield call(apiFetchAudit, action.payload);
    yield put(fetchAuditSuccess(data));
  } catch (error: any) {
    console.error('[EmailAuditSaga] fetchAudit error:', error);
    yield put(fetchAuditFailure('Failed to load email audit records'));
  }
}

export function* emailAuditSaga() {
  yield takeLatest(ActionTypes.FETCH_AUDIT_REQUEST, fetchAuditSaga);
}
